// Vee Exceptions Report Pie Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface VeeExceptionsReportPieChartProps {
  data: Array<{
    exceptiontype: string;
    [key: string]: any;
  }>;
}

const VeeExceptionsReportPieChart: React.FC<
  VeeExceptionsReportPieChartProps
> = ({ data }) => {
  const chartData = data?.map((item, index) => ({
    name: item.exceptiontype,
    value: 1,
    itemStyle: { color: ["#1976d2", "#9CE976"][index % 2] },
  }));

  const options = {
    tooltip: {
      trigger: "item",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      formatter: "{a} <br/>{b} : {c} kWh ({d}%)",
    },
    series: [
      {
        name: "Exceptions",
        type: "pie",
        radius: "85%",
        avoidLabelOverlap: false,
        data: chartData,
        //   itemStyle: {
        //     normal: {
        //       color: function (params) {
        //         const colorList = ;
        //         return colorList[params.dataIndex];
        //       },
        //     },
        //   },
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: "290px" }} />;
};

export default VeeExceptionsReportPieChart;
